import * as types from './constants';

// Remove Group Users
export const removeGroupUsersRequest = data => (
  { type: types.REMOVE_GROUP_USERS_REQUEST, payload: data }
);

export const removeGroupUsersDone = data => (
  { type: types.REMOVE_GROUP_USERS_DONE, payload: data }
);

export const removeGroupUsersFailed = errors => (
  { type: types.REMOVE_GROUP_USERS_FAILED, payload: errors }
);